const SUPABASE_URL = "https://idhxhcuomiygywnwohvb.supabase.co";
const PROXY_ENDPOINT = `${SUPABASE_URL}/functions/v1/proxy-image`;

const normalizeTikTokImageUrl = (url: string): string => {
  if (!url.includes('tiktokcdn')) return url;
  return url.replace(/\.heic(\?|$)/i, '.jpeg$1');
};

const isInstagramOrFacebookHost = (url: string): boolean => {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return (
      host.endsWith('cdninstagram.com') ||
      host.endsWith('instagram.com') ||
      host.endsWith('fbcdn.net') ||
      host.endsWith('facebook.com')
    );
  } catch {
    return false;
  }
};

/**
 * Normalises social-media CDN avatar URLs so they render in the browser.
 *
 * - TikTok: swap .heic → .jpeg (browsers can't decode HEIC) and serve
 *   directly — the TikTok CDN allows cross-origin image loads.
 * - Instagram / Facebook: route through our `proxy-image` edge function.
 *   IG/FB CDN blocks browser hotlinks (no Referer + signed URLs scoped to
 *   the IG origin), so a direct <img src=""> fails silently and falls back
 *   to the letter avatar. The edge function fetches server-side with the
 *   right Referer and streams the bytes back, which the browser happily
 *   renders.
 * - Anything else: return the URL unchanged.
 */
export const getProxiedImageUrl = (originalUrl: string | undefined | null): string => {
  if (!originalUrl || !originalUrl.trim()) return '';
  const url = originalUrl.trim();

  if (isInstagramOrFacebookHost(url)) {
    return `${PROXY_ENDPOINT}?url=${encodeURIComponent(url)}`;
  }

  return normalizeTikTokImageUrl(url);
};
